export type MetricFormat = 'int' | 'pct' | 'chf';

export function formatMetric(v: number | null | undefined, format: MetricFormat, locale: string): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  switch (format) {
    case 'pct':
      return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 1 }).format(v);
    case 'chf':
      return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
    default:
      return new Intl.NumberFormat(locale).format(v);
  }
}
